import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { TextoService } from './texto.service';
import { SolicitudAtestFitoService } from '../datosbasicos/datosbasicosAtestFito.service';
import { EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { TcPerfilUsuarioEnum } from '../../../core/_infrastructure/types/common';
import { EnumIdsTcTipoSolicitudAtestFito } from '../types/enum';
import { SolicitudAtestFitoTextoViewModel } from './texto.types';

@Component({
    selector: 'app-texto-edit',
    templateUrl: './texto-edit.component.html',
})
/** solicitud-edit component*/
export class TextoEditComponent extends ComponentBase implements OnInit {
    /** solicitud-edit ctor */

    //editMode: boolean = false;
    //editTitle: string = "Nueva";

    solicitudTextoAtestFito: SolicitudAtestFitoTextoViewModel;
    tituloEstadoSolicitud: string;
    habilitarGuardar = true;
    habilitarEdicion = true;
    visibilitySpinner = false;
    tituloTipoSolicitud: string;
    codigoTipoSolicitud: string;
    refAtestFito: string;

    textoAtestFito: string;
    textoAtestFitoUsuarioCaAc: string;
    IdTipoSolicitudAtestFito: number;
    IdEstadoSolicitudAtestFito: number;

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private navMenuService: NavMenuService,
        private solicitudAtestFitoService: SolicitudAtestFitoService,
        private textoService: TextoService,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.solicitudTextoAtestFito = new SolicitudAtestFitoTextoViewModel();
    }

    ngOnInit() {
        let id = +this.activatedRoute.snapshot.params['id'];

        this.guardRefreshPage(id);

        this.createForm();

        //Siempre tendrá un id.
        if (id) {
            this.loading = true;

            //recuperar la solicitud
            this.textoService.getSolicitudTextoAtestFito(id).subscribe(result => {
                this.solicitudTextoAtestFito = result;

                this.IdTipoSolicitudAtestFito = this.solicitudTextoAtestFito.IdTipoSolicitud;
                this.IdEstadoSolicitudAtestFito = this.solicitudTextoAtestFito.IdEstado;
                this.tituloTipoSolicitud = this.solicitudTextoAtestFito.IdTipoSolicitudDescripcion;
                this.tituloEstadoSolicitud = this.solicitudTextoAtestFito.IdEstadoDescripcion;
                this.codigoTipoSolicitud = this.solicitudTextoAtestFito.CodigoTipoSolicitud;

                this.refAtestFito = this.solicitudTextoAtestFito.RefAtestFito;

                this.updateForm();

                this.loading = false;

                this.habilitarGuardar = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.GUARDAR_TEXTO_ATESTACION,
                    this.solicitudTextoAtestFito.IdEstado,
                    this.solicitudTextoAtestFito.IdTipoSolicitud,
                ).Visible;
                this.habilitarEdicion = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.MENU_TEXTO_ATESTACION,
                    this.solicitudTextoAtestFito.IdEstado,
                    this.solicitudTextoAtestFito.IdTipoSolicitud,
                ).Editable;

                if (this.habilitarEdicion) {
                    //Si soy Solicitante
                    if (this.isSolicitante) {
                        this.form.controls['TextoAtestFitoUsuarioCaAc'].disable();
                    } else {
                        //Si es de tipo CA
                        if (this.solicitudTextoAtestFito.IdTipoSolicitud == EnumIdsTcTipoSolicitudAtestFito.ID_COMUNIDAD_AUTONOMA) {
                            if (this.isCA) {
                                this.form.controls['TextoAtestFito'].disable();
                            } else {
                                this.DisableControlsConsulta();
                            }
                        }
                        //Si es de tipo AC
                        else {
                            if (this.loggedInUser!.hasProfile(TcPerfilUsuarioEnum.AgenteControl)) {
                                this.form.controls['TextoAtestFito'].disable();
                            } else {
                                this.DisableControlsConsulta();
                            }
                        }
                    }
                } else {
                    this.DisableControlsConsulta();
                }
            });
        }
    }

    private DisableControlsConsulta() {
        this.form.controls['TextoAtestFito'].disable();
        this.form.controls['TextoAtestFitoUsuarioCaAc'].disable();
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudAtestacion.Id) || this.navMenuService.currentSolicitudAtestacion.Id !== id) {
            this.solicitudAtestFitoService.getSolicitudAtestFito(id).subscribe(result => {
                this.navMenuService.currentSolicitudAtestacion = result;
            });
        }
    }

    createForm() {
        this.form = this.fb.group({
            TextoAtestFito: '',
            TextoAtestFitoUsuarioCaAc: '',
        });
    }

    updateForm() {
        this.form.setValue({
            TextoAtestFito: this.solicitudTextoAtestFito.TextoAtestFito,
            TextoAtestFitoUsuarioCaAc: this.solicitudTextoAtestFito.TextoAtestFitoUsuarioCaAc,
        });

        this.textoAtestFito = this.solicitudTextoAtestFito.TextoAtestFito;
        this.textoAtestFitoUsuarioCaAc = this.solicitudTextoAtestFito.TextoAtestFitoUsuarioCaAc;
    }

    onBack() {
        this.router.navigate(['/exportacion/atestacion/datosbasicos', this.solicitudTextoAtestFito.Id]);
    }

    guardarTexto() {
        this.onSubmit();
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        this.visibilitySpinner = true;

        let solicitudTextoAtestFito = new SolicitudAtestFitoTextoViewModel();

        solicitudTextoAtestFito.Id = this.solicitudTextoAtestFito.Id;

        //Todo:agaro. 11/11/2020. Tenemos que revisar si está disabled el campo, que coja el valor almacenado.
        //DECL
        let textoAtestFito = this.form.value.TextoAtestFito;
        if (this.form.controls['TextoAtestFito'].disabled) {
            textoAtestFito = this.textoAtestFito; //Valor almacenado
        }

        //DECL. Inspector
        let textoAtestFitoUsuarioCaAc = this.form.value.TextoAtestFitoUsuarioCaAc;
        if (this.form.controls['TextoAtestFitoUsuarioCaAc'].disabled) {
            textoAtestFitoUsuarioCaAc = this.textoAtestFitoUsuarioCaAc; //Valor almacenado
        }

        solicitudTextoAtestFito.TextoAtestFito = textoAtestFito;
        solicitudTextoAtestFito.TextoAtestFitoUsuarioCaAc = textoAtestFitoUsuarioCaAc;

        this.textoService.editSolicitudTextoAtestFito(solicitudTextoAtestFito).subscribe({
            next: res => {
                this.addSuccessMessage('Texto de informe guardado correctamente');
                //this.onBack();
                this.visibilitySpinner = false;
            },
            error: error => {
                this.catchServerError(error);
                this.visibilitySpinner = false;
            },
        });
    }
}
